import axios from 'axios'
import { APIS } from '../config'

export const getToggle = async( toggleId ) => {
  try {
    const response = await axios.get( `${APIS.OEF_BASE_URL}/v2/toggle/${toggleId}` )
    return response.data.enabled
  } catch ( error ) {
    return false
  }
}
